import React from 'react';
import RetirementPlanner from './components/RetirementPlanner';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4">
        </div>
      </header>
      <main>
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <RetirementPlanner />
        </div>
      </main>
    </div>
  );
}
export default App;